import { getAuthenticatedClient } from '../supabase/authenticatedClient';
import { supabase } from '../supabase/client';

export const getContacts = async () => {
  const { data, error } = await supabase
    .from('contacts')
    .select(
      `
      *,
      contact_comments (
        id,
        comment,
        created_at,
        user_id
      )
    `
    )
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return data;
};

export const createContact = async contactData => {
  const client = await getAuthenticatedClient();

  // Get current destination/city
  const { data: cityData, error: cityError } = await client
    .from('cities')
    .select('id')
    .limit(1)
    .single();

  if (cityError) {
    throw cityError;
  }

  // Add city_id to contact data
  const contactWithCity = {
    ...contactData,
    city_id: cityData.id,
  };

  const { data, error } = await client.from('contacts').insert([contactWithCity]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateContact = async (id, contactData) => {
  const client = await getAuthenticatedClient();

  // Get current destination/city if not already set
  if (!contactData.city_id) {
    const { data: cityData, error: cityError } = await client
      .from('cities')
      .select('id')
      .limit(1)
      .single();

    if (cityError) {
      throw cityError;
    }

    contactData.city_id = cityData.id;
  }

  const { data, error } = await client
    .from('contacts')
    .update(contactData)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteContact = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('contacts').delete().eq('id', id);

  if (error) {
    throw error;
  }
};

export const addContactComment = async (contactId, comment) => {
  const client = await getAuthenticatedClient();
  const {
    data: { user },
  } = await supabase.auth.getUser();

  const { data, error } = await client
    .from('contact_comments')
    .insert([
      {
        contact_id: contactId,
        user_id: user.id,
        user_email: user.email,
        comment,
      },
    ])
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
